export const REGISTER_USER_STEP_IDS = [
  'search',
  'confirmation',
  'size',
  'admin',
  'receipt',
] as const

export type RegisterUserStepId = typeof REGISTER_USER_STEP_IDS[number]

export const REGISTER_USER_STEP_LABELS = {
  confirmation: 'Bekreft bedrift',
  size: 'Antall jurister',
  admin: 'Opprett administrator',
} as const satisfies Partial<
  Record<RegisterUserStepId, string>
>

export type RegisterUserHeaderStepId = keyof typeof REGISTER_USER_STEP_LABELS
